import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { colors } from "../../Shared/colors";
import AddIcon from "@mui/icons-material/Add";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import { TextField, Autocomplete, Button as MuiButton, IconButton, InputAdornment } from "@mui/material";
import { Puff } from "react-loader-spinner";
import {
  useGetAllProjectsQuery,
  useGetSingleProjectQuery,
} from "../../features/projectSlice";
import { useCreateInventoryMutation, useGetAllInventoryQuery } from "../../features/InventorySlice";
import { toast, Toaster } from "react-hot-toast";
import Papa from "papaparse";
import { InventoryDataTable } from "./InventoryDataTable";
import { decryptData } from "../../services/crypto";

export const InventoryFirst = () => {
  const [popUp, setpopUp] = useState(false);
  const [areaType, setareaType] = useState("");
  const [loading, setloading] = useState(false);
  // const [inventoryData, setinventoryData] = useState([])
  const [invenQuery, setinvenQuery] = useState({
    project: "",
    unitType: "",
    projectBlock: "",
    unitNo: "",
    status: "",
    bed: "",
    location: "",
    crossArea: "",
    features: "",
    plotSize: "",
    minPrice: "",
    maxPrice: "",
    minMarlaPrice: "",
    maxMarlaPrice: "",
    areaInFet: "",
    areaInMarla: "",
  });

  const [invenValues, setinvenValues] = useState({
    project: "",
    unitType: "",
    projectBlock: "",
    unitNo: "",
    status: "",
    bed: "",
    location: "",
    crossArea: "",
    features: "",
    plotSize: "",
    minPrice: "",
    maxPrice: "",
    minMarlaPrice: "",
    maxMarlaPrice: "",
    areaInFet: "",
    areaInMarla: "",
  });

  const {
    data:InventoryData,
    refetch: refetchInventory,
  } = useGetAllInventoryQuery({
    project: invenQuery.project,
    unitType: invenQuery.unitType,
    projectBlock: invenQuery.projectBlock,
    unitNo: invenQuery.unitNo,
    status: invenQuery.status,
    bed: invenQuery.bed,
    location: invenQuery.location,
    crossArea: invenQuery.crossArea,
    features: invenQuery.features,
    plotSize: invenQuery.plotSize,
    minPrice: invenQuery.minPrice,
    maxPrice: invenQuery.maxPrice,
    minMarlaPrice: invenQuery.minMarlaPrice,
    maxMarlaPrice: invenQuery.maxMarlaPrice,
    areaInFet: invenQuery.areaInFet,
    areaInMarla: invenQuery.areaInMarla,
  })

  let role = null;
    let storedStaffRole = localStorage.getItem("role");
  
    if (storedStaffRole) {
      try {
        role = decryptData(storedStaffRole);
      } catch (error) {
        console.error("Failed to decrypt data:", error);
      }
    }
  
  useEffect(() => {
    const handleEscape = (event) => {
      if (event.keyCode === 27) {
        setpopUp(false);
      }
    };

    document.addEventListener("keydown", handleEscape);

    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, []);


  let handleInveQueryChange = (e) => {
    let { name, value } = e.target;
    setinvenValues({
      ...invenValues,
      [name]: value,
    });
  };

  let handleGetInvenQuery = () =>{
    setinvenQuery(invenValues)
    refetchInventory()
    .then((res)=>{
      toast.success("inventory loaded successfully!")
    })
    .catch((err)=>{
      toast.error("Error while loading inventory!")
    })
  }

  const [inventory, setinventory] = useState({
    projectId: "",
    unitNo: "",
    invenType: "",
    bed: "",
    marlaPrice: null,
    totalPrice: null,
    areaInFet: "",
    areaInMarla: "",
    plotSize: "",
    location: "",
    crossArea: "",
    features: "",
    projectBlockName: "",
    sqftPrice: null,
    status: "",
  });

  let { data: project } = useGetAllProjectsQuery();

  const handleProject = (e) => {
    let { name, value } = e.target;
    setloading(true);
    setinventory({ ...inventory, [name]: value });
  };
  let { data: singleProject } = useGetSingleProjectQuery(inventory.projectId);

  useEffect(() => {
    if (singleProject) {
      setloading(false);
    }
  }, [singleProject]);

  let handleArea = (e) => {
    if (e.target.value === "areaInFeet") {
      setareaType(e.target.value);
    } else {
      setareaType(e.target.value);
    }
  };

  let handleChange = (e) => {
    let { name, value } = e.target;
    if (e.target.name === "totalPrice" || e.target.name === "marlaPrice") {
      setinventory({ ...inventory, [name]: parseInt(value) });
    } else {
      setinventory({ ...inventory, [name]: value });
    }
  };

  let [addInventory, { isLoading }] = useCreateInventoryMutation();

  const handleInventorySubmit = (e) => {
    e.preventDefault();

    addInventory({
      projectID: inventory.projectId,
      unitNo: inventory.unitNo,
      invenType: inventory.invenType,
      bed: inventory.bed,
      marlaPrice: inventory.marlaPrice,
      totalPrice: inventory.totalPrice,
      areaInFet: inventory.areaInFet,
      areaInMarla: inventory.areaInMarla,
      plotSize: inventory.plotSize,
      location: inventory.location,
      crossArea: inventory.crossArea,
      features: inventory.features,
      projectBlockName: inventory.projectBlockName,
      sqftPrice: inventory.sqftPrice,
      status: inventory.status,
    })
      .unwrap()
      .then(() => {
        toast.success("Inventory created successfully");
        setpopUp(false);
    setinventory({
      projectId: "",
      unitNo: "",
      invenType: "",
      bed: "",
      marlaPrice: null,
      totalPrice: null,
      areaInFet: "",
      areaInMarla: "",
      plotSize: "",
      location: "",
      crossArea: "",
      features: "",
      projectBlockName: "",
      sqftPrice: null,
      status: "",
    });
    setareaType("");
      })
      .catch((err) => {
        toast.error(err?.data?.error?.message || "Failed to create inventory");
      });
  };

  const handleFileUpload = async (e) => {
    const files = e.target.files;
    let bulk = [];

    if (files) {
      Papa.parse(files[0], {
        complete: function (results) {
          results.data.map((site) =>
            bulk.push({
              unitNo: site[0],
              invenType: site[1],
              bed: site[2],
              marlaPrice: site[3],
              totalPrice: site[4],
              areaInFet: site[5],
              areaInMarla: site[6],
              plotSize: site[7],
              location: site[8],
              crossArea: site[9],
              features: site[10],
              sqftPrice: site[11],
              status: site[12],
              projectID: inventory.projectId,
              projectBlockName: inventory.projectBlockName,
            })
          );
          for (let i = 0; i < bulk.length; i++) {
            addInventory(bulk[i])
              .unwrap()
              .then(() => {
                toast.success("inventory added successfully");
              })
              .catch((err) => {
                toast.error(err.data.error.message);
              });
          }
        },
      });
    }
    e.target.value = "";
  };

  return (
    <>
    <Main>
      <Search>
        <AffiliateSection>
          <Heading>
            <SearchIcon style={{ fontSize: '1.5rem', color: colors.brown }} />
            <SubHeading>Search Inventory</SubHeading>
          </Heading>
          {role === "hr" ||
          role === "v3" ||
          role === "developer" ||
          role === "director" ||
          role === "ceo" ? (
            <MuiButton
              variant="contained"
              startIcon={<AddIcon />}
              onClick={() => setpopUp(!popUp)}
              sx={{
                background: colors.brown,
                color: colors.white,
                '&:hover': {
                  background: '#1f7f7f',
                },
              }}
            >
              Add Inventory
            </MuiButton>
          ) : null}
        </AffiliateSection>
        <SearchSection1>
          <InputSection>
            <Autocomplete
              size="small"
              options={project || []}
              getOptionLabel={(option) => option.projectName || ""}
              value={project?.find(p => p._id === invenValues.project) || null}
              onChange={(e, value) => {
                handleInveQueryChange({
                  target: { name: "project", value: value?._id || "" }
                });
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Project"
                  variant="outlined"
                  placeholder="Select project"
                />
              )}
              sx={{
                '& .MuiOutlinedInput-root': {
                  backgroundColor: colors.white,
                  borderRadius: '8px',
                },
              }}
            />
          </InputSection>

          <InputSection>
            <TextField
              fullWidth
              size="small"
              label="Project Block"
              name="projectBlock"
              id="projectBlock"
              placeholder="Enter project block"
              value={invenValues.projectBlock}
                  onChange={handleInveQueryChange}
              variant="outlined"
              InputProps={{
                endAdornment: invenValues.projectBlock && (
                  <InputAdornment position="end">
                    <IconButton 
                      onClick={() => handleInveQueryChange({ target: { name: "projectBlock", value: "" } })} 
                      size="small"
                    >
                      <ClearIcon fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              sx={{
                '& .MuiOutlinedInput-root': {
                  backgroundColor: colors.white,
                  borderRadius: '8px',
                },
              }}
            />
          </InputSection>

          <InputSection>
            <Autocomplete
              size="small"
              options={[
                { value: "apartments", label: "Apartments" },
                { value: "house", label: "House" },
                { value: "plot", label: "Plot" },
              ]}
              getOptionLabel={(option) => option.label || ""}
              value={
                invenValues.unitType
                  ? { value: invenValues.unitType, label: invenValues.unitType.charAt(0).toUpperCase() + invenValues.unitType.slice(1) }
                  : null
              }
              onChange={(e, value) => {
                handleInveQueryChange({
                  target: { name: "unitType", value: value?.value || "" }
                });
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Unit Type"
                  variant="outlined"
                  placeholder="Select unit type"
                />
              )}
              sx={{
                '& .MuiOutlinedInput-root': {
                  backgroundColor: colors.white,
                  borderRadius: '8px',
                },
              }}
            />
          </InputSection>

          <InputSection>
            <TextField
              fullWidth
              size="small"
              label="Bed"
              name="bed"
              id="bed"
              placeholder="e.g., 2, 3, 4"
              value={invenValues.bed}
              onChange={handleInveQueryChange}
              variant="outlined"
              InputProps={{
                endAdornment: invenValues.bed && (
                  <InputAdornment position="end">
                    <IconButton 
                      onClick={() => handleInveQueryChange({ target: { name: "bed", value: "" } })} 
                      size="small"
                    >
                      <ClearIcon fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              sx={{
                '& .MuiOutlinedInput-root': {
                  backgroundColor: colors.white,
                  borderRadius: '8px',
                },
              }}
            />
          </InputSection>

          <InputSection>
            <TextField
              fullWidth
              size="small"
              label="Location"
              name="location"
              id="location"
              placeholder="e.g., Street 10, Block A"
              value={invenValues.location}
              onChange={handleInveQueryChange}
              variant="outlined"
              InputProps={{
                endAdornment: invenValues.location && (
                  <InputAdornment position="end">
                    <IconButton 
                      onClick={() => handleInveQueryChange({ target: { name: "location", value: "" } })} 
                      size="small"
                    >
                      <ClearIcon fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              sx={{
                '& .MuiOutlinedInput-root': {
                  backgroundColor: colors.white,
                  borderRadius: '8px',
                },
              }}
            />
          </InputSection>
        </SearchSection1>
        <SearchSection2>
          <InputSection>
            <TextField
              fullWidth
              size="small"
              label="Unit No"
              name="unitNo"
              id="unitNo"
              placeholder="Enter unit number"
              value={invenValues.unitNo}
              onChange={handleInveQueryChange}
              variant="outlined"
              InputProps={{
                endAdornment: invenValues.unitNo && (
                  <InputAdornment position="end">
                    <IconButton 
                      onClick={() => handleInveQueryChange({ target: { name: "unitNo", value: "" } })} 
                      size="small"
                    >
                      <ClearIcon fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              sx={{
                '& .MuiOutlinedInput-root': {
                  backgroundColor: colors.white,
                  borderRadius: '8px',
                },
              }}
            />
          </InputSection>
          <InputSection>
            <Autocomplete
              size="small"
              options={[
                { value: "Available", label: "Available" },
                { value: "Sold", label: "Sold" },
                { value: "Reserved", label: "Reserved" },
              ]}
              getOptionLabel={(option) => option.label || ""}
              value={
                invenValues.status
                  ? { value: invenValues.status, label: invenValues.status }
                  : null
              }
              onChange={(e, value) => {
                handleInveQueryChange({
                  target: { name: "status", value: value?.value || "" }
                });
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Status"
                  variant="outlined"
                  placeholder="Select status"
                />
              )}
              sx={{
                '& .MuiOutlinedInput-root': {
                  backgroundColor: colors.white,
                  borderRadius: '8px',
                },
              }}
            />
          </InputSection>

          <InputSection>
            <TextField
              fullWidth
              size="small"
              label="Cross Area"
              name="crossArea"
              id="crossArea"
              placeholder="e.g., Corner, Park Facing"
              value={invenValues.crossArea}
              onChange={handleInveQueryChange}
              variant="outlined"
              InputProps={{
                endAdornment: invenValues.crossArea && (
                  <InputAdornment position="end">
                    <IconButton 
                      onClick={() => handleInveQueryChange({ target: { name: "crossArea", value: "" } })} 
                      size="small"
                    >
                      <ClearIcon fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              sx={{
                '& .MuiOutlinedInput-root': {
                  backgroundColor: colors.white,
                  borderRadius: '8px',
                },
              }}
            />
          </InputSection>

          <InputSection>
            <TextField
              fullWidth
              size="small"
              label="Features"
              name="features"
              id="features"
              placeholder="e.g., Basement, Servant Quarter"
              value={invenValues.features}
              onChange={handleInveQueryChange}
              variant="outlined"
              InputProps={{
                endAdornment: invenValues.features && (
                  <InputAdornment position="end">
                    <IconButton 
                      onClick={() => handleInveQueryChange({ target: { name: "features", value: "" } })} 
                      size="small"
                    >
                      <ClearIcon fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              sx={{
                '& .MuiOutlinedInput-root': {
                  backgroundColor: colors.white,
                  borderRadius: '8px',
                },
              }}
            />
          </InputSection>

          <InputSection>
            <TextField
              fullWidth
              size="small"
              label="Plot Size"
              name="plotSize"
              id="plotSize"
              placeholder="e.g., 5 Marla, 10 Marla"
              value={invenValues.plotSize}
              onChange={handleInveQueryChange}
              variant="outlined"
              InputProps={{
                endAdornment: invenValues.plotSize && (
                  <InputAdornment position="end">
                    <IconButton 
                      onClick={() => handleInveQueryChange({ target: { name: "plotSize", value: "" } })} 
                      size="small"
                    >
                      <ClearIcon fontSize="small" />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              sx={{
                '& .MuiOutlinedInput-root': {
                  backgroundColor: colors.white,
                  borderRadius: '8px',
                },
              }}
            />
          </InputSection>
        </SearchSection2>
        <SearchSection3>
          <PriceRangeLabel>Price Range</PriceRangeLabel>
          <PriceRangeRow>
            <InputSection>
              <TextField
                fullWidth
                size="small"
                label="Min Total Price"
                name="minPrice"
                id="minPrice"
                type="number"
                placeholder="e.g., 1000000"
                value={invenValues.minPrice}
                onChange={handleInveQueryChange}
                variant="outlined"
                InputProps={{
                  endAdornment: invenValues.minPrice && (
                    <InputAdornment position="end">
                      <IconButton 
                        onClick={() => handleInveQueryChange({ target: { name: "minPrice", value: "" } })} 
                        size="small"
                      >
                        <ClearIcon fontSize="small" />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    backgroundColor: colors.white,
                    borderRadius: '8px',
                  },
                }}
              />
            </InputSection>
            <InputSection>
              <TextField
                fullWidth
                size="small"
                label="Max Total Price"
                name="maxPrice"
                id="maxPrice"
                type="number"
                placeholder="e.g., 10000000"
                value={invenValues.maxPrice}
                onChange={handleInveQueryChange}
                variant="outlined"
                InputProps={{
                  endAdornment: invenValues.maxPrice && (
                    <InputAdornment position="end">
                      <IconButton 
                        onClick={() => handleInveQueryChange({ target: { name: "maxPrice", value: "" } })} 
                        size="small"
                      >
                        <ClearIcon fontSize="small" />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    backgroundColor: colors.white,
                    borderRadius: '8px',
                  },
                }}
              />
            </InputSection>
            <InputSection>
              <TextField
                fullWidth
                size="small"
                label="Min Marla Price"
                name="minMarlaPrice"
                id="minMarlaPrice"
                type="number"
                placeholder="e.g., 500000"
                value={invenValues.minMarlaPrice}
                onChange={handleInveQueryChange}
                variant="outlined"
                InputProps={{
                  endAdornment: invenValues.minMarlaPrice && (
                    <InputAdornment position="end">
                      <IconButton 
                        onClick={() => handleInveQueryChange({ target: { name: "minMarlaPrice", value: "" } })} 
                        size="small"
                      >
                        <ClearIcon fontSize="small" />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    backgroundColor: colors.white,
                    borderRadius: '8px',
                  },
                }}
              />
            </InputSection>
            <InputSection>
              <TextField
                fullWidth
                size="small"
                label="Max Marla Price"
                name="maxMarlaPrice"
                id="maxMarlaPrice"
                type="number"
                placeholder="e.g., 5000000"
                value={invenValues.maxMarlaPrice}
                onChange={handleInveQueryChange}
                variant="outlined"
                InputProps={{
                  endAdornment: invenValues.maxMarlaPrice && (
                    <InputAdornment position="end">
                      <IconButton 
                        onClick={() => handleInveQueryChange({ target: { name: "maxMarlaPrice", value: "" } })} 
                        size="small"
                      >
                        <ClearIcon fontSize="small" />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    backgroundColor: colors.white,
                    borderRadius: '8px',
                  },
                }}
              />
            </InputSection>
          </PriceRangeRow>
        </SearchSection3>
        <SearchSection4>
          <AreaRangeLabel>Area Range</AreaRangeLabel>
          <AreaRangeRow>
            <InputSection>
              <TextField
                fullWidth
                size="small"
                label="Area In Feet"
                name="areaInFet"
                id="areaInFet"
                placeholder="e.g., 1200"
                value={invenValues.areaInFet}
                onChange={handleInveQueryChange}
                variant="outlined"
                InputProps={{
                  endAdornment: invenValues.areaInFet && (
                    <InputAdornment position="end">
                      <IconButton 
                        onClick={() => handleInveQueryChange({ target: { name: "areaInFet", value: "" } })} 
                        size="small"
                      >
                        <ClearIcon fontSize="small" />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    backgroundColor: colors.white,
                    borderRadius: '8px',
                  },
                }}
              />
            </InputSection>
            <InputSection>
              <TextField
                fullWidth
                size="small"
                label="Area In Marla"
                name="areaInMarla"
                id="areaInMarla"
                placeholder="e.g., 5, 10"
                value={invenValues.areaInMarla}
                onChange={handleInveQueryChange}
                variant="outlined"
                InputProps={{
                  endAdornment: invenValues.areaInMarla && (
                    <InputAdornment position="end">
                      <IconButton 
                        onClick={() => handleInveQueryChange({ target: { name: "areaInMarla", value: "" } })} 
                        size="small"
                      >
                        <ClearIcon fontSize="small" />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    backgroundColor: colors.white,
                    borderRadius: '8px',
                  },
                }}
              />
            </InputSection>
          </AreaRangeRow>
        </SearchSection4>
        <FilterActions>
          <MuiButton
            variant="outlined"
            startIcon={<ClearIcon />}
            onClick={() => {
              const clearedValues = {
                project: "",
                unitType: "",
                projectBlock: "",
                unitNo: "",
                status: "",
                bed: "",
                location: "",
                crossArea: "",
                features: "",
                plotSize: "",
                minPrice: "",
                maxPrice: "",
                minMarlaPrice: "",
                maxMarlaPrice: "",
                areaInFet: "",
                areaInMarla: "",
              };
              setinvenValues(clearedValues);
              setinvenQuery(clearedValues);
              refetchInventory();
            }}
            sx={{
              borderColor: colors.brown,
              color: colors.brown,
              '&:hover': {
                borderColor: '#1f7f7f',
                color: '#1f7f7f',
                background: 'rgba(36, 147, 147, 0.05)',
              },
            }}
          >
            Clear Filters
          </MuiButton>
          <MuiButton
            variant="contained"
            startIcon={<SearchIcon />}
            onClick={handleGetInvenQuery}
            sx={{
              background: colors.brown,
              color: colors.white,
              '&:hover': {
                background: '#1f7f7f',
              },
            }}
          >
            Search
          </MuiButton>
        </FilterActions>
      </Search>
      <PopUpContainer popUp={popUp}>
        <PopUp>
          <PopUpHeader>
            <PopUpTitle>Add Inventory</PopUpTitle>
            <Cross onClick={() => {
              setpopUp(false);
              setinventory({
                projectId: "",
                unitNo: "",
                invenType: "",
                bed: "",
                marlaPrice: null,
                totalPrice: null,
                areaInFet: "",
                areaInMarla: "",
                plotSize: "",
                location: "",
                crossArea: "",
                features: "",
                projectBlockName: "",
                sqftPrice: null,
                status: "",
              });
              setareaType("");
            }}>
            <img src="/assets/icons/cross.png" alt="cross" />
          </Cross>
          </PopUpHeader>
          <PopUpSection onSubmit={handleInventorySubmit}>
            <Section>
              <Task>
                <InputPart>
                  <InputFeild>
                    <h3>Unit No:</h3>
                    <input
                      type="text"
                      name="unitNo"
                      id="unitNo"
                      value={inventory.unitNo}
                      onChange={handleChange}
                      placeholder="e.g., A-12, 101, Plot-5"
                    />
                  </InputFeild>
                  <InputFeild>
                    <h3>Inventory Type:</h3>
                    <div>
                      <select
                        name="invenType"
                        id="invenType"
                        onChange={handleChange}
                      >
                        <option value="">select</option>
                        <option value="apartments">Apartments</option>
                        <option value="house">House</option>
                        <option value="plot">Plot</option>
                      </select>
                    </div>
                  </InputFeild>
                  <InputFeild>
                    <h3>Bed:</h3>
                    <input
                      type="text"
                      name="bed"
                      id="bed"
                      value={inventory.bed}
                      onChange={handleChange}
                      placeholder="e.g., 2, 3, 4"
                    />
                  </InputFeild>
                  <InputFeild>
                    <h3>Area Type:</h3>
                    <div>
                      <select
                        name="areaType"
                        id="areaType"
                        onChange={handleArea}
                      >
                        <option value="">select</option>
                        <option value="areaInFeet">Area In Feet</option>
                        <option value="areaInMarla">Area In Marla</option>
                      </select>
                    </div>
                  </InputFeild>
                  {areaType === "areaInFeet" ? (
                    <InputFeild>
                      <h3>Area In Feet:</h3>
                      <input
                        type="text"
                        name="areaInFet"
                        id="areaInFet"
                        value={inventory.areaInFet}
                        onChange={handleChange}
                        placeholder="e.g., 1200"
                      />
                    </InputFeild>
                  ) : null}
                  {areaType === "areaInMarla" ? (
                    <InputFeild>
                      <h3>Area in Marla:</h3>
                      <input
                        type="text"
                        name="areaInMarla"
                        id="areaInMarla"
                        value={inventory.areaInMarla}
                        onChange={handleChange}
                        placeholder="e.g., 5, 10"
                      />
                    </InputFeild>
                  ) : null}
                  <InputFeild>
                    <h3>Cross Area:</h3>
                    <input
                      type="text"
                      name="crossArea"
                      id="crossArea"
                      value={inventory.crossArea}
                      onChange={handleChange}
                      placeholder="e.g., Corner, Park Facing"
                    />
                  </InputFeild>
                  <InputFeild>
                    <h3>Project:</h3>
                    <div>
                      <select
                        name="projectId"
                        id="projectId"
                        onChange={handleProject}
                      >
                        <option value="">Select Project</option>
                        {project?.map((pro) => (
                          <option value={pro._id}>{pro.projectName}</option>
                        ))}
                      </select>
                    </div>
                  </InputFeild>
                  {loading ? (
                    <Loader>
                      <Puff
                        height="40"
                        width="40"
                        radius={1}
                        color={colors.brown}
                        ariaLabel="puff-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                        visible={true}
                      />
                    </Loader>
                  ) : null}
                  {singleProject?.projectBlock?.length > 0 ? (
                    <InputFeild>
                      <h3>Project Block:</h3>
                      <div>
                        <select
                          name="projectBlockName"
                          id="projectBlockName"
                          value={inventory.projectBlockName}
                          onChange={handleChange}
                        >
                          <option value="">select</option>
                          {singleProject?.projectBlock?.map((pro) => (
                            <option value={pro.blockName}>
                              {pro.blockName}
                            </option>
                          ))}
                        </select>
                      </div>
                    </InputFeild>
                  ) : null}
                  <InputFeild>
                    <h3>Features:</h3>
                    <input
                      type="text"
                      name="features"
                      id="features"
                      value={inventory.features}
                      onChange={handleChange}
                      placeholder="e.g., Basement, Servant Quarter"
                    />
                  </InputFeild>
                  <InputFeild>
                    <h3>Plot Size:</h3>
                    <input
                      type="text"
                      name="plotSize"
                      id="plotSize"
                      value={inventory.plotSize}
                      onChange={handleChange}
                      placeholder="e.g., 5 Marla, 10 Marla"
                    />
                  </InputFeild>
                  <InputFeild>
                    <h3>Total Price:</h3>
                    <input
                      type="text"
                      name="totalPrice"
                      id="totalPrice"
                      value={inventory.totalPrice}
                      onChange={handleChange}
                      placeholder="e.g., 4500000"
                    />
                  </InputFeild>
                  <InputFeild>
                    <h3>Marla Price:</h3>
                    <input
                      type="text"
                      name="marlaPrice"
                      id="marlaPrice"
                      value={inventory.marlaPrice}
                      onChange={handleChange}
                      placeholder="e.g., 900000"
                    />
                  </InputFeild>
                  <InputFeild>
                    <h3>Square Feet Price:</h3>
                    <input
                      type="text"
                      name="sqftPrice"
                      id="sqftPrice"
                      value={inventory.sqftPrice}
                      onChange={handleChange}
                      placeholder="e.g., 3500"
                    />
                  </InputFeild>
                  <InputFeild>
                    <h3>Status:</h3>
                    <input
                      type="text"
                      name="status"
                      id="status"
                      value={inventory.status}
                      onChange={handleChange}
                      placeholder="e.g., Available"
                    />
                  </InputFeild>
                  <InputFeild>
                    <h3>Location:</h3>
                    <input
                      type="text"
                      name="location"
                      id="location"
                      value={inventory.location}
                      onChange={handleChange}
                      placeholder="e.g., Street 10, Block A"
                    />
                  </InputFeild>
                </InputPart>
              </Task>
              <ButtonPart>
                <button
                  type="button"
                  onClick={() => {
                    setpopUp(false);
                    setinventory({
                      projectId: "",
                      unitNo: "",
                      invenType: "",
                      bed: "",
                      marlaPrice: null,
                      totalPrice: null,
                      areaInFet: "",
                      areaInMarla: "",
                      plotSize: "",
                      location: "",
                      crossArea: "",
                      features: "",
                      projectBlockName: "",
                      sqftPrice: null,
                      status: "",
                    });
                    setareaType("");
                  }}
                >
                  Cancel
                </button>
              </ButtonPart>
            </Section>
            <Section>
              <Task>
                <InputPart>
                  <InputFeild>
                    <h3>Project:</h3>
                    <div>
                      <select
                        name="projectId"
                        id="projectId"
                        onChange={handleProject}
                      >
                        <option value="">Select Project</option>
                        {project?.map((pro) => (
                          <option value={pro._id}>{pro.projectName}</option>
                        ))}
                      </select>
                    </div>
                  </InputFeild>
                  {loading ? (
                    <Loader>
                      <Puff
                        height="40"
                        width="40"
                        radius={1}
                        color={colors.brown}
                        ariaLabel="puff-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                        visible={true}
                      />
                    </Loader>
                  ) : null}
                  {singleProject?.projectBlock?.length > 0 ? (
                    <InputFeild>
                      <h3>Project Block:</h3>
                      <div>
                        <select
                          name="projectBlockName"
                          id="projectBlockName"
                          value={inventory.projectBlockName}
                          onChange={handleChange}
                        >
                          <option value="">select</option>
                          {singleProject?.projectBlock?.map((pro) => (
                            <option value={pro.blockName}>
                              {pro.blockName}
                            </option>
                          ))}
                        </select>
                      </div>
                    </InputFeild>
                  ) : null}

                  <InputFeild>
                    <h3>Attachment:</h3>
                    <span>
                      <p>Upload CSV for bulk inventory (optional)</p>
                      <label htmlFor="profilePic">
                        <AttachFileIcon /> Upload
                      </label>
                    </span>
                    <input
                      type="file"
                      name="profilePic"
                      id="profilePic"
                      onChange={(e) => handleFileUpload(e)}
                    />
                  </InputFeild>
                </InputPart>
              </Task>
              <ButtonPart>
                <button
                  type="submit"
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <>
                      <Puff height="16" width="16" color={colors.white} visible={true} />
                      Saving...
                    </>
                  ) : (
                    <>Save Inventory</>
                  )}
                </button>
              </ButtonPart>
            </Section>
          </PopUpSection>
        </PopUp>
      </PopUpContainer>
      <Toaster />
    </Main>
      <InventoryDataTable inventoryData={InventoryData}/>
    </>
  );
};

const Main = styled.div`
  width: 90%;
  max-width: 1400px;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  min-height: 30vh;
  margin: 0 auto;
`;

const AffiliateSection = styled.div`
  width: 100%;
  color: ${colors.text};
  border-bottom: 1px solid ${colors.inputBorderWhite};
  padding-bottom: 1em;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Heading = styled.div`
    display: flex;
    align-items: center;
  gap: 0.75rem;
`;

const Search = styled.div`
  background-color: ${colors.white};
  width: 100%;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 16px;
  min-height: 19em;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  padding: 1.5rem;
`;

const SubHeading = styled.h4`
  font-size: clamp(1.2em, 1.2vw, 1.5em);
  font-weight: 600;
  margin: 0;
`;

const SearchSection1 = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 1rem;
`;

const SearchSection2 = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 1rem;
  align-items: flex-end;
`;

const SearchSection3 = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 12px;
  border: 1px solid ${colors.inputBorderWhite};
`;

const PriceRangeLabel = styled.h4`
  font-size: 1rem;
  font-weight: 600;
  color: ${colors.text};
  margin: 0;
`;

const PriceRangeRow = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 1rem;
`;

const SearchSection4 = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
  border-radius: 12px;
  border: 1px solid ${colors.inputBorderWhite};
`;

const AreaRangeLabel = styled.h4`
  font-size: 1rem;
  font-weight: 600;
  color: ${colors.text};
  margin: 0;
`;

const AreaRangeRow = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 1rem;
`;

const InputSection = styled.div`
  min-width: 2em;
    width: 100%;
`;

const FilterActions = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  align-items: center;
  padding-top: 0.5rem;
  border-top: 1px solid ${colors.inputBorderWhite};
  margin-top: 0.5rem;
`;

const PopUpContainer = styled.div`
  background-color: rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(4px);
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 1000;
  display: ${(props) => (props.popUp ? "flex" : "none")};
  justify-content: center;
  align-items: center;
  padding: 2rem;
  animation: ${(props) => (props.popUp ? "fadeIn 0.3s ease" : "none")};
  
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
`;

const PopUp = styled.div`
  width: 90%;
  max-width: 1200px;
  max-height: 90vh;
  background-color: ${colors.white};
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  animation: slideUp 0.3s ease;
  
  @keyframes slideUp {
    from {
      transform: translateY(20px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
`;

const PopUpHeader = styled.div`
  width: 100%;
  padding: 1.5rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid ${colors.inputBorderWhite};
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
`;

const PopUpTitle = styled.h3`
  font-size: 1.5rem;
  font-weight: 600;
  color: ${colors.text};
  margin: 0;
`;

const Cross = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  transition: all 0.2s ease;
  color: ${colors.text};
  
  &:hover {
    background: rgba(0, 0, 0, 0.05);
    transform: rotate(90deg);
  }
  
  img {
    width: 24px;
    height: 24px;
    object-fit: contain;
  }
`;

const PopUpSection = styled.form`
  flex: 1;
  display: flex;
  overflow: hidden;
  position: relative;
`;

const Section = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  padding: 2rem;
  overflow-y: auto;
  
  &:first-child {
    border-right: 1px solid ${colors.inputBorderWhite};
  }
  
  &::-webkit-scrollbar {
    width: 8px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }
  
  &::-webkit-scrollbar-thumb {
    background: ${colors.brown};
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: #1a6b6b;
  }
`;

const Task = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const InputPart = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
`;

const InputFeild = styled.div`
  width: 100%;
  h3 {
    color: ${colors.text};
    font-size: 0.9rem;
    font-weight: 500;
    margin: 0 0 0.5rem 0;
  }
  div {
    position: relative;
    border: 1px solid ${colors.inputBorderWhite};
    border-radius: 8px;
    width: 100%;
    background-color: ${colors.white};
    transition: all 0.2s ease;
    
    &:hover {
      border-color: ${colors.brown};
    }
    
    &:focus-within {
      border-color: ${colors.brown};
      box-shadow: 0 0 0 3px rgba(36, 147, 147, 0.1);
    }
    
    select,
    input[type="date"] {
      background-color: ${colors.white};
      width: 100%;
      padding: 0.75rem 1rem;
      outline: none;
      border: none;
      border-radius: 8px;
      font-size: 0.95rem;
      color: ${colors.text};
      cursor: pointer;
      ::placeholder {
        color: ${colors.inputFeild};
      }
    }
  }
  input,
  textarea {
    border: 1px solid ${colors.inputBorderWhite};
    border-radius: 8px;
    background-color: ${colors.white};
    width: 100%;
    padding: 0.75rem 1rem;
    outline: none;
    font-size: 0.95rem;
    color: ${colors.text};
    transition: all 0.2s ease;
    
    &:hover {
      border-color: ${colors.brown};
    }
    
    &:focus {
      border-color: ${colors.brown};
      box-shadow: 0 0 0 3px rgba(36, 147, 147, 0.1);
    }
    
    ::placeholder {
      color: ${colors.inputFeild};
    }
  }
  textarea {
    min-height: 120px;
    resize: vertical;
  }
  span {
    background-color: ${colors.white};
    padding: 0.75rem 1rem;
    border-radius: 8px;
    border: 2px dashed ${colors.inputBorderWhite};
    display: flex;
    position: relative;
    align-items: center;
    justify-content: space-between;
    transition: all 0.2s ease;
      cursor: pointer;
    
    &:hover {
      border-color: ${colors.brown};
      background: rgba(36, 147, 147, 0.02);
    }
    
    label {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      background: linear-gradient(135deg, ${colors.brown} 0%, #1a6b6b 100%);
      color: ${colors.white};
      padding: 0.5rem 1rem;
      border-radius: 6px;
      cursor: pointer;
      font-weight: 500;
      font-size: 0.9rem;
      transition: all 0.2s ease;
      
      &:hover {
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(36, 147, 147, 0.3);
      }
    }
    p {
      font-size: 0.9rem;
      color: ${colors.textMed};
      margin: 0;
    }
  }
  input[type="file"] {
    display: none;
  }
`;

const ButtonPart = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  padding-top: 1.5rem;
  margin-top: auto;
  border-top: 1px solid ${colors.inputBorderWhite};
  
  button {
    padding: 0.75rem 1.5rem;
    border-radius: 10px;
    outline: none;
    border: none;
    cursor: pointer;
    font-weight: 500;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    
    &:first-child {
      background: ${colors.white};
      color: ${colors.text};
      border: 1px solid ${colors.inputBorderWhite};
      
      &:hover {
        background: #f8f9fa;
        color: ${colors.text};
        border-color: ${colors.text};
      }
    }
    
    &:last-child {
      background: ${colors.brown};
      color: ${colors.white};
      box-shadow: 0 4px 12px rgba(36, 147, 147, 0.28);
      
      &:hover:not(:disabled) {
        background: #1f7f7f;
        color: ${colors.white};
        transform: translateY(-2px);
        box-shadow: 0 6px 16px rgba(36, 147, 147, 0.34);
      }
      
      &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
        color: ${colors.white};
      }
    }
  }
`;

const Loader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
`;
